import {useEffect, useState} from 'react';
import {useFetchCallQuery} from '../../../store/features/calls/callsService';
import {CallInsightsDrawer} from './CallInsightsDrawer';
import {
    clearInsightsReturnFocus,
    peekInsightsReturnFocus,
    takeInsightsEntry,
    useInsightsDrawerParams,
    type InsightsEntry,
} from './useInsightsDrawerParams';

const OpenDrawer = ({callId, params}: {callId: number; params: ReturnType<typeof useInsightsDrawerParams>}) => {
    const [initialTime] = useState(() => params.time);
    const [entry] = useState<InsightsEntry>(() => takeInsightsEntry());
    const [returnFocus] = useState(peekInsightsReturnFocus);
    useEffect(() => {
        clearInsightsReturnFocus();
    }, []);
    const {data: call, isLoading, isError} = useFetchCallQuery(callId);
    return (
        <CallInsightsDrawer
            callId={callId}
            call={call}
            callLoading={isLoading}
            callFailed={isError}
            tab={params.tab}
            initialTime={initialTime}
            entry={entry}
            returnFocus={returnFocus}
            onTabChange={params.setTab}
            onClose={params.close}
        />
    );
};

export const CallInsightsDrawerHost = () => {
    const params = useInsightsDrawerParams();
    if (params.callId == null) return null;
    return <OpenDrawer key={params.callId} callId={params.callId} params={params}/>;
};
